import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/workspace/tarbot/src/features/auth/components/reset-password-form.tsx");
